<template>
		<div class="footer">
			<div class="w1200">
				<div class="info">
					<span>协会电话： 010-8352 0973</span>
					<span>协会地址： 北京市丰台区花乡高立庄616号新华国际中心D座401室</span>
					<span>协会邮箱： bbsca2016@163.com</span>
				</div>
				<p class="copyright">2011-2015 Copyrights reserved 京ICP备2023005587号-1 版权所有：北京建筑设施服务企业协会</p>

			</div>
		</div>
</template>

<script>

	export default {

		data() {
			return {

			}
		},
		methods: {

		},
		components: {}
	}
</script>

<style>
	@import "../assets/css/common.css";
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue